module.exports = __webpack_public_path__ + "static/img/nav_6.fa441bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/nav_6.svg
// module id = rLow
// module chunks = 2